import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { subscribeUserFavourites, setUserProfile, updateUserFavourites, clearUserFavourites } from '../../actions/userProfileActions';
import './navbar.css';
import firebase from 'firebase/app'; // ← 여기 수정
import 'firebase/auth';

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            favouriteSubscribe: undefined
        }
    }

    componentDidMount() {
        let self = this;
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                const uid = user.uid;
                const email = user.email;

                console.log('onAuthStateChanged is called : ', uid, email);
                self.props.setUserProfile(uid, email);
                const favouriteSubscribe = self.props.subscribeUserFavourites(uid);
                self.setState({
                    favouriteSubscribe: favouriteSubscribe
                });
            } else {
                console.log('onAuthStateChanged is called (signed out)');
                const favouriteSubscribe = self.state.favouriteSubscribe;
                if(favouriteSubscribe){
                    favouriteSubscribe();
                }
                self.props.setUserProfile('', '');
                self.props.clearUserFavourites();
            }
        });
    }

    handleLogout = event => {
        event.preventDefault();
        console.log('handleLogout is called');
        firebase.auth().signOut()
            .then(() => {
                console.log('signOut is called');
            })
            .catch(error => {
                console.log('signOut error : ', error.code, error.message);
            });
    };

    render() {
        console.log('Navbar props : ', this.props);

        let loginView = null;
        if(this.props.userProfile.email){
            loginView = (
                <div>
                    <div className="download hidden-xs">
                        <a href='https://play.google.com/store/apps/details?id=com.sofajoa.ctcae5cloud&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target='_blank' rel="noopener noreferrer">
                            <img alt='Get it on Google Play' width="100%" src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/>
                        </a>
                    </div>
                    <div className="menu-item">{this.props.userProfile.email}</div>
                    <div className="menu-item">
                        <div onClick={this.handleLogout}>Logout</div>
                    </div>
                </div>
            );
        } else {
            loginView = (
                <div>
                    <div className="download hidden-xs">
                        <a href='https://play.google.com/store/apps/details?id=com.sofajoa.ctcae5cloud&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target='_blank' rel="noopener noreferrer">
                            <img alt='Get it on Google Play' width="100%" src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/>
                        </a>
                    </div>
                    <div className="menu-item">
                        <Link to='/login'>Login</Link>
                    </div>
                </div>
            );
        }

        return (
            <div className="title-container">
                <div className="container-fluid">
                    <div className="main">
                        <div className="row">
                            <div className="col-sm-3 hidden-xs">
                                <div className="title">
                                    <img width='100' height='30' src={ require('../../assets/images/CC_title.png') } alt="CTCAE CLOUD" />
                                </div>
                            </div>
                            <div className="visible-xs col-xs-12">
                                <div>
                                    <div className="mobile-menu-icon"><i className="fa fa-bars fa-2x"/></div>
                                    <div className="title">CTCAE v5</div>
                                    <div className="pull-right menu">{loginView}</div>
                                </div>
                            </div>
                            <div className="col-sm-2 hidden-xs">
                                <div className="menu">
                                    <div className="list-item">
                                        <Link to='/ctcae6'>CTCAE v6</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-2 hidden-xs">
                                <div className="menu">
                                    <div className="list-item">
                                        <Link to='/ctcae5'>CTCAE v5</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-5 hidden-xs">
                                <div className="pull-right menu">{loginView}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile
});

export default connect(mapStateToProps, { setUserProfile, updateUserFavourites, subscribeUserFavourites, clearUserFavourites })(Navbar);


// WEBPACK FOOTER //
// ./src/component/navbar/navbar.js